<!-- @format -->

<app-create-asin-header></app-create-asin-header>

<div
	class="land-bg"
	style="{{ minHeight }}"
>
	<div
		class="container mb-4"
		style="{{ minHeight2 }}"
	>
		<div style="padding: 50px 30px">
			<div class="row justify-content-center">
				<div class="col-md-7">
					<div class="question-card">
						<h4 class="text-center">Corporate ASIN Enrollment</h4>
						<br />

						<form
							[formGroup]="firstForm"
							(ngSubmit)="onSubmit()"
						>
							<div formGroupName="businessDetails">
								<div
									class="cac-form"
									*ngIf="!valid"
								>
									<div class="cac-form-body">
										<div class="cac-form-input">
											<div class="input-group-div">
												<label class="required"
													>CAC RC Number
													(RC/IT/LP/LLP)</label
												>
												<input
													id="rcNumber"
													placeholder="Enter RC Number"
													formControlName="rcNumber"
												/>
											</div>
											<div class="input-group-div">
												<label>Company Name</label>
												<input
													placeholder="Company Name"
													formControlName="companyName"
												/>
											</div>
										</div>
										<button
											type="button"
											class="btn btn-gold d-flex justify-content-center align-items-center gap-2"
											(click)="validateRcNumber()"
										>
											<b
												*ngIf="isValidating"
												class="spinner-border text-white"
											></b>
											Validate
										</button>
									</div>
									<small
										*ngIf="
											firstForm.get(
												'businessDetails.rcNumber'
											)?.invalid &&
											firstForm.get(
												'businessDetails.rcNumber'
											)?.touched
										"
										class="text-danger"
										>This field is required</small
									>
								</div>
								<div
									class="row"
									*ngIf="valid"
								>
									<div class="col-md-12 mb-3">
										<div class="input-group-div">
											<label class="required"
												>Business / Corporate
												Name</label
											>
											<input
												id="business_name"
												formControlName="business_name"
												readonly
											/>
										</div>
										<small
											*ngIf="
												firstForm.get(
													'businessDetails.business_name'
												)?.invalid &&
												firstForm.get(
													'businessDetails.business_name'
												)?.touched
											"
											class="text-danger"
											>This field is required</small
										>
									</div>
									<div class="col-md-6 mb-3">
										<div class="input-group-div">
											<label class="required"
												>Email Address</label
											>
											<input
												formControlName="email"
												(change)="emailExists()"
											/>
										</div>
										<small
											*ngIf="
												firstForm.get(
													'businessDetails.email'
												)?.invalid &&
												firstForm.get(
													'businessDetails.email'
												)?.touched
											"
											class="text-danger"
											>Enter a valid email</small
										>
										<small
											*ngIf="emailExist"
											class="text-danger"
											>E-mail already in use</small
										>
									</div>
									<div class="col-md-6 mb-3">
										<div class="input-group-div">
											<label class="required"
												>Phone Number</label
											>
											<input
												formControlName="phone"
												(change)="phoneExists()"
												type="number"
											/>
										</div>
										<small
											*ngIf="
												firstForm
													.get(
														'businessDetails.phone'
													)
													?.hasError(
														'invalidPhoneNumber'
													) ||
												(firstForm.get(
													'businessDetails.phone'
												)?.invalid &&
													firstForm.get('phone')
														?.touched)
											"
											class="text-danger"
											>Enter a valid phone number</small
										>
										<small
											*ngIf="phoneExist"
											class="text-danger"
											>Phone Number already in use</small
										>
									</div>
									<div class="col-md-6 mb-3">
										<div class="input-group-div">
											<label class="required"
												>CAC RC Number
												(RC/IT/LP/LLP)</label
											>
											<input
												formControlName="rcNumber"
												readonly
											/>
										</div>
										<small
											*ngIf="
												firstForm.get(
													'businessDetails.rcNumber'
												)?.invalid &&
												firstForm.get(
													'businessDetails.rcNumber'
												)?.touched
											"
											class="text-danger"
											>Enter a valid phone number</small
										>
									</div>
									<div class="col-md-6 mb-3">
										<div class="input-group-div">
											<label class="required"
												>Registration Date</label
											>
											<input
												formControlName="regDate"
												type="date"
											/>
										</div>
										<small
											*ngIf="
												firstForm.get(
													'businessDetails.regDate'
												)?.invalid &&
												firstForm.get(
													'businessDetails.regDate'
												)?.touched
											"
											class="text-danger"
											>Enter a valid phone number</small
										>
									</div>
									<div class="col-md-6 mb-3">
										<div class="input-group-div">
											<label class="required"
												>Create New Password</label
											>
											<div class="pwd-eyes">
												<input
													id="password"
													[type]="
														!eyeOpen
															? 'password'
															: 'text'
													"
													formControlName="password"
													[minlength]="6"
													[maxlength]="50"
												/>
												<svg
													(click)="toggleEye()"
													*ngIf="eyeOpen"
													fill="#A98204"
													width="24px"
													height="24px"
													viewBox="0 0 32 32"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g
														id="SVGRepo_bgCarrier"
														stroke-width="0"
													></g>
													<g
														id="SVGRepo_tracerCarrier"
														stroke-linecap="round"
														stroke-linejoin="round"
													></g>
													<g id="SVGRepo_iconCarrier">
														<title>eye</title>
														<path
															d="M30.564 15.506c-9.59-10.957-19.543-10.957-29.129 0-0.115 0.131-0.185 0.305-0.185 0.494s0.070 0.363 0.186 0.495l-0.001-0.001c4.793 5.479 9.693 8.256 14.563 8.256h0.001c4.869 0 9.771-2.777 14.564-8.256 0.116-0.131 0.186-0.304 0.186-0.494s-0.070-0.363-0.187-0.495l0.001 0.001zM3.004 16c8.704-9.626 17.291-9.622 25.992 0-8.703 9.621-17.291 9.621-25.992 0zM16 11.25c-2.623 0-4.75 2.127-4.75 4.75s2.127 4.75 4.75 4.75c2.623 0 4.75-2.127 4.75-4.75v0c-0.003-2.622-2.128-4.747-4.75-4.75h-0zM16 19.25c-1.795 0-3.25-1.455-3.25-3.25s1.455-3.25 3.25-3.25c1.795 0 3.25 1.455 3.25 3.25v0c-0.002 1.794-1.456 3.248-3.25 3.25h-0z"
														></path>
													</g>
												</svg>
												<svg
													(click)="toggleEye()"
													*ngIf="!eyeOpen"
													fill="#A98204"
													width="24px"
													height="24px"
													viewBox="0 0 32 32"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g
														id="SVGRepo_bgCarrier"
														stroke-width="0"
													></g>
													<g
														id="SVGRepo_tracerCarrier"
														stroke-linecap="round"
														stroke-linejoin="round"
													></g>
													<g id="SVGRepo_iconCarrier">
														<title>eye-slash</title>
														<path
															d="M18.822 22.904c-5.215 1.275-10.524-1.051-15.818-6.904 1.337-1.501 2.79-2.843 4.364-4.034l0.076-0.055c0.186-0.138 0.305-0.357 0.305-0.604 0-0.414-0.336-0.75-0.75-0.75-0.166 0-0.32 0.054-0.444 0.146l0.002-0.001c-1.91 1.447-3.588 3.024-5.086 4.761l-0.036 0.042c-0.115 0.131-0.185 0.305-0.185 0.494s0.070 0.363 0.186 0.495l-0.001-0.001c4.803 5.488 9.693 8.254 14.582 8.254 1.123-0.001 2.212-0.142 3.252-0.406l-0.092 0.020c0.332-0.082 0.573-0.377 0.573-0.729 0-0.414-0.336-0.75-0.75-0.75-0.064 0-0.125 0.008-0.184 0.023l0.005-0.001zM16.75 20c-0-0.414-0.336-0.75-0.75-0.75v0c-1.794-0.002-3.248-1.456-3.25-3.25v-0c0-0.414-0.336-0.75-0.75-0.75s-0.75 0.336-0.75 0.75v0c0.003 2.622 2.128 4.747 4.75 4.75h0c0.414-0 0.75-0.336 0.75-0.75v0zM23.565 22.503c2.701-1.672 5.010-3.665 6.965-5.967l0.034-0.042c0.116-0.131 0.186-0.304 0.186-0.494s-0.070-0.363-0.187-0.495l0.001 0.001c-6.844-7.82-13.822-10.081-20.758-6.76l-7.277-7.276c-0.135-0.131-0.32-0.212-0.523-0.212-0.414 0-0.75 0.336-0.75 0.75 0 0.203 0.081 0.388 0.213 0.523l27.999 28.001c0.136 0.136 0.324 0.22 0.531 0.22 0.415 0 0.751-0.336 0.751-0.751 0-0.207-0.084-0.395-0.22-0.531v0zM28.996 16c-1.852 2.121-4.004 3.919-6.402 5.345l-0.121 0.067-2.636-2.635c0.569-0.767 0.911-1.731 0.912-2.776v-0c-0.003-2.622-2.128-4.747-4.75-4.75h-0c-1.045 0.002-2.009 0.344-2.789 0.921l0.013-0.009-2.29-2.29c6.027-2.647 11.95-0.64 18.062 6.127zM14.301 13.239c0.486-0.307 1.077-0.489 1.711-0.489 1.788 0 3.238 1.45 3.238 3.238 0 0.634-0.182 1.225-0.497 1.724l0.008-0.013z"
														></path>
													</g>
												</svg>
											</div>
										</div>
										<small
											*ngIf="
												firstForm.get(
													'businessDetails.password'
												).invalid &&
												firstForm.get(
													'businessDetails.password'
												).touched
											"
											class="text-danger"
											>Password should contain at least 6
											characters, an uppercase letter, a
											number and special characters</small
										>
									</div>
									<div class="col-md-6 mb-3">
										<div class="input-group-div">
											<label class="required"
												>Confirm Password</label
											>
											<div class="pwd-eyes">
												<input
													[type]="
														!eyeOpenConfirm
															? 'password'
															: 'text'
													"
													formControlName="confirm_password"
													(change)="checkPassword()"
													[minlength]="6"
													[maxlength]="50"
												/>
												<svg
													(click)="toggleEyeConfirm()"
													*ngIf="eyeOpenConfirm"
													fill="#A98204"
													width="24px"
													height="24px"
													viewBox="0 0 32 32"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g
														id="SVGRepo_bgCarrier"
														stroke-width="0"
													></g>
													<g
														id="SVGRepo_tracerCarrier"
														stroke-linecap="round"
														stroke-linejoin="round"
													></g>
													<g id="SVGRepo_iconCarrier">
														<title>eye</title>
														<path
															d="M30.564 15.506c-9.59-10.957-19.543-10.957-29.129 0-0.115 0.131-0.185 0.305-0.185 0.494s0.070 0.363 0.186 0.495l-0.001-0.001c4.793 5.479 9.693 8.256 14.563 8.256h0.001c4.869 0 9.771-2.777 14.564-8.256 0.116-0.131 0.186-0.304 0.186-0.494s-0.070-0.363-0.187-0.495l0.001 0.001zM3.004 16c8.704-9.626 17.291-9.622 25.992 0-8.703 9.621-17.291 9.621-25.992 0zM16 11.25c-2.623 0-4.75 2.127-4.75 4.75s2.127 4.75 4.75 4.75c2.623 0 4.75-2.127 4.75-4.75v0c-0.003-2.622-2.128-4.747-4.75-4.75h-0zM16 19.25c-1.795 0-3.25-1.455-3.25-3.25s1.455-3.25 3.25-3.25c1.795 0 3.25 1.455 3.25 3.25v0c-0.002 1.794-1.456 3.248-3.25 3.25h-0z"
														></path>
													</g>
												</svg>
												<svg
													(click)="toggleEyeConfirm()"
													*ngIf="!eyeOpenConfirm"
													fill="#A98204"
													width="24px"
													height="24px"
													viewBox="0 0 32 32"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g
														id="SVGRepo_bgCarrier"
														stroke-width="0"
													></g>
													<g
														id="SVGRepo_tracerCarrier"
														stroke-linecap="round"
														stroke-linejoin="round"
													></g>
													<g id="SVGRepo_iconCarrier">
														<title>eye-slash</title>
														<path
															d="M18.822 22.904c-5.215 1.275-10.524-1.051-15.818-6.904 1.337-1.501 2.79-2.843 4.364-4.034l0.076-0.055c0.186-0.138 0.305-0.357 0.305-0.604 0-0.414-0.336-0.75-0.75-0.75-0.166 0-0.32 0.054-0.444 0.146l0.002-0.001c-1.91 1.447-3.588 3.024-5.086 4.761l-0.036 0.042c-0.115 0.131-0.185 0.305-0.185 0.494s0.070 0.363 0.186 0.495l-0.001-0.001c4.803 5.488 9.693 8.254 14.582 8.254 1.123-0.001 2.212-0.142 3.252-0.406l-0.092 0.020c0.332-0.082 0.573-0.377 0.573-0.729 0-0.414-0.336-0.75-0.75-0.75-0.064 0-0.125 0.008-0.184 0.023l0.005-0.001zM16.75 20c-0-0.414-0.336-0.75-0.75-0.75v0c-1.794-0.002-3.248-1.456-3.25-3.25v-0c0-0.414-0.336-0.75-0.75-0.75s-0.75 0.336-0.75 0.75v0c0.003 2.622 2.128 4.747 4.75 4.75h0c0.414-0 0.75-0.336 0.75-0.75v0zM23.565 22.503c2.701-1.672 5.010-3.665 6.965-5.967l0.034-0.042c0.116-0.131 0.186-0.304 0.186-0.494s-0.070-0.363-0.187-0.495l0.001 0.001c-6.844-7.82-13.822-10.081-20.758-6.76l-7.277-7.276c-0.135-0.131-0.32-0.212-0.523-0.212-0.414 0-0.75 0.336-0.75 0.75 0 0.203 0.081 0.388 0.213 0.523l27.999 28.001c0.136 0.136 0.324 0.22 0.531 0.22 0.415 0 0.751-0.336 0.751-0.751 0-0.207-0.084-0.395-0.22-0.531v0zM28.996 16c-1.852 2.121-4.004 3.919-6.402 5.345l-0.121 0.067-2.636-2.635c0.569-0.767 0.911-1.731 0.912-2.776v-0c-0.003-2.622-2.128-4.747-4.75-4.75h-0c-1.045 0.002-2.009 0.344-2.789 0.921l0.013-0.009-2.29-2.29c6.027-2.647 11.95-0.64 18.062 6.127zM14.301 13.239c0.486-0.307 1.077-0.489 1.711-0.489 1.788 0 3.238 1.45 3.238 3.238 0 0.634-0.182 1.225-0.497 1.724l0.008-0.013z"
														></path>
													</g>
												</svg>
											</div>
										</div>
										<small class="text-danger">{{
											errorMSG
										}}</small>
									</div>
								</div>
							</div>
							<br />

							<!-- [disabled]="firstForm.invalid" -->
							<p
								style="
									color: #fc7e7e;
									font-size: 15px;
									text-align: center;
								"
							>
								{{ PassErrorMsg }}
							</p>
							<div
								class="submit-div mt-3 row"
								*ngIf="valid"
							>
								<div class="col-md-6">
									<button
										type="button"
										style="height: 47px"
										class="cancel"
										(click)="cancel()"
									>
										Back
									</button>
								</div>
								<div class="col-md-6">
									<button
										type="submit"
										[disabled]="
											firstForm.get('personalDetails')
												?.invalid ||
											emailExist ||
											phoneExist
										"
										style="height: 47px"
										class="button"
									>
										Proceed
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>

	<app-footer></app-footer>
</div>
